export const WordArtParamDescs = {
    coloredStroke: [
        {
            tag: 'LabelColor',
            attrs: {
                label: '颜色 1',
                showAlpha: true
            },
            prop: 'color1'
        },
        {
            tag: 'LabelColor',
            attrs: {
                label: '颜色 2',
                showAlpha: true
            },
            prop: 'color2'
        },
        {
            tag: 'LabelColor',
            attrs: {
                label: '颜色 3',
                showAlpha: true
            },
            prop: 'color3'
        },
        {
            tag: 'LabelColor',
            attrs: {
                label: '颜色 4',
                showAlpha: true
            },
            prop: 'color4'
        },
        {
            tag: 'LabelInput',
            attrs: {
                label: '描边段长',
                min: 1,
                precision: 0,
                percentage: true
            },
            prop: 'stepSize'
        },
        {
            tag: 'LabelInput',
            attrs: {
                label: '描边段间距',
                min: 0,
                precision: 0,
                percentage: true
            },
            prop: 'stepGap'
        },
        {
            tag: 'LabelInput',
            attrs: {
                label: '描边宽度',
                min: 1,
                precision: 0
            },
            prop: 'strokeWidth'
        }
    ],
    shadowFade: [
        {
            tag: 'LabelColor',
            attrs: {
                label: '颜色'
            },
            prop: 'color'
        },
        {
            tag: 'LabelColor',
            attrs: {
                label: '阴影颜色'
            },
            prop: 'shadowColor'
        },
        {
            tag: 'LabelInput',
            attrs: {
                label: '阴影深度',
                min: 1,
                max: 30,
                precision: 0
            },
            prop: 'shadowDepth'
        }
    ]
};

export const WordArtParams = {
    coloredStroke: {
        color1: '#fb8',
        color2: '#e4a',
        color3: '#3e9',
        color4: '#28e',
        stepSize: 10,
        stepGap: 0,
        strokeWidth: 3
    },
    shadowFade: {
        color: '#007eff',
        shadowColor: '#ccc',
        shadowDepth: 20
    }
}